// Fieldwork.js
//
// Used to have 3 tabs (Sync Dashboard / Execute Requests / Bank
// Transactions). Execute Requests moved to its own page under Users
// (below Member Requests) and Bank Transactions (ConsolidatedWithdrawals)
// moved to its own page under Payments as "Outgoing Payments" — see
// lib/navigation.js and App.js. Fieldwork itself stays where it was, but
// with only Sync Dashboard left there's no reason for a tab bar over a
// single view, so this just renders SyncDashboard directly now.
//
// This used to also wrap SyncDashboard in its own p:3 Box with its own
// page background — that was stacking on top of whatever padding/
// background the app's shared route layout already applies, which is why
// this page rendered narrower/more inset than sibling pages like
// ExecuteRequests. Rendering SyncDashboard directly, with no extra
// wrapper, lets it fill the same width every other route does.
import React from 'react';
import SyncDashboard from './syncs';

const Fieldwork = () => {
  return <SyncDashboard />;
};

export default Fieldwork;